import type { FaireProductEntity } from "../../entity_types/product";

export const p_aj8tbwtant: FaireProductEntity = {
  token: "p_aj8tbwtant",
  type: "product",
  name: 'Wide Optic Highball-5.5"H(12oz)',
  brandToken: "b_a8n58zvndo",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.faire.com/fastly/807e188b3c8b041e3c9aea4c9412a9abb855e18715147981b227cf5b5a6e089d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a4dcfae04472a0cc81ed49109a3a44f3f42134331c8bc170acb8060f72c912cb.jpeg",
    "https://cdn.faire.com/fastly/7f6f1f2f19a59d6a6e7f34bccf2d2d38911d915dd760e947c8c58303dd00cff6.jpeg",
    "https://cdn.faire.com/fastly/16f333f0cc3eb8da9c8e2ec37320b6718b367e981c593117b4c01d5847968b79.jpeg",
  ],
  priceDollars: 4,
  description:
    "This Wide Optic Hiball features a wide base and an optic design, creating a unique and eye-catching appearance. The optic pattern adds texture and visual interest to the glass, while its sturdy construction ensures durability for everyday use. Embrace modern elegance and elevate your table setting with this artfully designed tumbler, perfect for any occasion.",
  tags: [],
  msrpDollars: 8,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T19:58:12.848Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
